<div class="marriottForm" [formGroup]="marriottForm">
  <div class="marriottForm__logo" *ngIf="isMobile">
    <img loading="lazy" [src]="'logo-marriott-bonvoy.svg' | ImageCdn" alt="Marriott Bonvoy Logo">
  </div>

  <div class="marriottForm__desktop-cont">
    <div class="marriottForm__desktop-cont-input">
      <app-alert-message 
        [text]="'BOOKING_MODULE.MARRIOTT_BONVOY.FORM_INFO' | transloco"
        [alertType]="alertType">
      </app-alert-message>

      <app-form-text-input
        [form]="marriottForm"
        [formControlSelector]="flyerSelector"
        [id]="flyerSelector"
        [maxLength]="20"
        [isSubmitted]="isSubmitted"
        [formInputType]="documentInput"
        [inputDocumentType]="alphanumericType"
        [label]="'BOOKING_MODULE.MARRIOTT_BONVOY.MEMBER_NUMBER_OF' | transloco : { name: defaultPaxFullName }"
        [placeholder]="'BOOKING_MODULE.MARRIOTT_BONVOY.INSERT_NUMBER' | transloco">
      </app-form-text-input>
    </div>

    <div class="marriottForm__desktop-cont-text">
      <div class="marriottForm__logo" *ngIf="!isMobile">
        <img loading="lazy" [src]="'logo-marriott-bonvoy.svg' | ImageCdn" alt="Marriott Bonvoy Logo">
      </div>
      <!-- Temporarily Disabled -->
      <ng-container *ngIf="false">
      <div class="marriottForm__attention-line">
        <span>
          <span>
            <img [src]="'agente-soporte.png' | ImageCdn" alt="Support Agent">
          </span>
        </span>
          <div class="marriottForm__attention-line__text">
            <h5>{{'BOOKING_MODULE.MARRIOTT_BONVOY.FORGOT_NUMBER' | transloco }}</h5>
            <a [innerHTML]="'BOOKING_MODULE.MARRIOTT_BONVOY.CLICK_WEBSITE' | transloco"></a>
          </div>
      </div>
      </ng-container>
      <!-- / Temporarily Disabled -->
    </div>
  </div>

  <div class="marriottForm__buttons">
    <div class="marriottForm__buttons__button-cont">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.MARRIOTT_BONVOY.SAVE_NUMBER' | transloco }"
        [isLoading]="isLoadingPaxForm"
        (clickEvent)="save()">
      </app-ds-button>
    </div>
    <div class="marriottForm__buttons__button-cont">
      <app-ds-button
        [type]="becomeMemberButtonType"
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.MARRIOTT_BONVOY.BECOME_A_MEMBER' | transloco }"
        (clickEvent)="createMarriottBonvoyNumber.emit()">
      </app-ds-button>
    </div>
  </div>
</div>
